module.exports = __webpack_public_path__ + "img/expostyle_9631_spring_green_pantone363c.39ec0ef5.jpg";